<div class="toggle-switch-container">
    <label class="toggle-switch" [class.toggle-switch--sm]="size === 'sm'">
        <input
            type="checkbox"
            [checked]="value"
            [disabled]="disabled"
            (change)="onToggle($any($event.target).checked)"
        />
        <div>
            <div *ngIf="value; else offIconTemplate">
                <fa-icon [icon]="onIcon"></fa-icon>
            </div>
            <ng-template #offIconTemplate>
                <div>
                    <fa-icon [icon]="offIcon"></fa-icon>
                </div>
            </ng-template>
        </div>
    </label>
    <span class="toggle-label" *ngIf="label">{{ label }}</span>
    <span class="toggle-label" *ngIf="!label"><ng-content></ng-content></span>
</div>
